import { UITypes } from "types"

export const dateSelectOptions: UITypes.Option[] = [
  { label: "Last 7 days", value: "7" },
  { label: "Last 14 days", value: "14" },
  { label: "Last 30 days", value: "30" },
  { label: "Last 60 days", value: "60" },
  { label: "Last 90 days", value: "90" },
]

export const allDateSelectOptions: UITypes.Option[] = [
  { label: "All Time", value: "all" },
  ...dateSelectOptions,
  { label: "Last Year", value: "last-year" },
  { label: "This year", value: "this-year" },
  { label: "Custom", value: "custom" },
]
